import { Fragment } from 'react';

import { ReactComponent as ArrowIcon } from '@assets/img/icons/arrow-down.svg';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
}

const AutoComplete = ({
  value = null,
  onChange = () => {},
  onBlur = () => {},
  label = '',
  options = [],
  required = false,
  error,
  helperText,
  useFlag = false,
  style = {},
  ...props
}) => {
  return (
    <Autocomplete
      options={options}
      style={{ ...style }}
      value={value}
      onChange={(e, val) => onChange(val)}
      onBlur={onBlur}
      popupIcon={<ArrowIcon />}
      autoHighlight
      getOptionLabel={(option) => option.label}
      getOptionSelected={(option, value) => value && option.code === value.code}
      renderOption={(option) => (
        <Fragment>
          {useFlag && <span>{countryToFlag(option.code)}</span>}
          {option.label} ({option.code})
        </Fragment>
      )}
      {...props}
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          {...params}
          required={required}
          size="small"
          label={label}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
          {...props}
        />
      )}
    />
  );
};

export default AutoComplete;
